import { call, put, takeEvery, select } from "redux-saga/effects";
import { fetchAPI } from "../../utils/service";
import endpoints, { endpointTypes } from "../../service";
import generatePdfDocument from "./summaryPDFDownload";
import * as ACTIONS from "./actionCreators";
import * as CART_ACTIONS from "../MyCart/actionCreators";
import * as ACTION_TYPES from "./actionTypes";
import * as GlobalAction from "../../globalStore/actions";
import * as DYNAMIC_FORM_ACTIONS from "../../components/DynamicForm/actionCreators";
import * as CONFIG from "../../../config.json";
import { PersistData } from "../../middleware/persistDataMiddleware";
import { getPersistData, setPersistData } from "../../utils/utils";

const REST_ENDPOINT = endpoints[endpointTypes.THANK_YOU].endpoints;

let validateCount = 0;

export const getWarrantyId = (state) => {
    return state.dynamicFormInfo && state.dynamicFormInfo.warrantyId;
};
/**
 * Initialize transaction
 * @param payload
 * @ignore
 */
export function* initiateTransaction({ payload }: ReturnType<typeof ACTIONS.initiateTransaction>) {
    const warrantyId = yield select(getWarrantyId);
    yield put(ACTIONS.updateInitTransaction());
    if (warrantyId) {
        const endpoint = REST_ENDPOINT.beginTransaction({ warrantyId: warrantyId, ...payload });
        try {
            const response = yield call(fetchAPI, endpoint);
            if (response) {
                yield put(ACTIONS.updateNavigation(response.data));
            }
        } catch (err) {
            yield put(GlobalAction.showGlobalError(err));
        }
    } else {
        yield put(GlobalAction.showGlobalError(""));
    }
    yield put(ACTIONS.updateInitTransactionCompleted());
}

/**
 * validate payment by transaction id
 * @param payload
 * @ignore
 */
export function* validatePayment({ payload }: ReturnType<typeof ACTIONS.validateTransaction>) {
    const endpoint = REST_ENDPOINT.validateTransaction({
        id: payload.id,
        status: payload.status,
    });
    try {
        let warrantyId = "";
        if (payload.isMakeValidateTransaction) {
            validateCount++;
            const response = yield call(fetchAPI, endpoint);
            if (response && response.data && payload.status === 1) {
                const pdfData = {};
                yield put(ACTIONS.updateTransactionData(response.data));
                validateCount = 0;
                warrantyId = response.data.warrantyId;
                let persistData: PersistData = getPersistData() || {};
                persistData = Object.assign(persistData, {
                    warrantyId,
                });
                setPersistData(persistData);
                // yield put(ACTIONS.updateTransactionData(pdfData));
                // warrantyId = response.data.warrantyId;
            } else {
                if (response && response.data) {
                    yield put(CART_ACTIONS.getActiveShoppingCartSuccess({ data: response.data }));
                }
            }
        } else {
            warrantyId = payload.id;
        }
        if (warrantyId) {
            let pdfData = {};
            const endpointCheck = REST_ENDPOINT.checkAutoGenerate(warrantyId);
            try {
                const responseCheck = yield call(fetchAPI, endpointCheck);
                if (responseCheck) {
                    pdfData = responseCheck.data;
                }
                yield put(ACTIONS.updateTransactionData(pdfData));
            } catch (err) {
                yield put(GlobalAction.showGlobalError(err));
            }
        }
        if ( (payload.isMakeValidateTransaction && payload.status === 1)) {
            // Commented below line to avoid /DownloadWarrantySummaryPDF/{WarrantyNumber} API call on page load after Resubmit warranty
            // !payload.isMakeValidateTransaction || 
            const warrantyNumber = payload.warrantyNumber;
            const reviewAndPayEndpoint = REST_ENDPOINT.reviewAndPay.endpoints.getReviewAndPay(warrantyNumber);
            try {
                const reviewAndPayResponse = yield call(fetchAPI, reviewAndPayEndpoint);
                if (reviewAndPayResponse) {
                    yield put(DYNAMIC_FORM_ACTIONS.setReviewAndPayData({ value: reviewAndPayResponse.data }));
                }
            } catch (err) {
                yield put(GlobalAction.showGlobalError(err));
            }
        } else if (payload.status === 2 || payload.status === 3) {
            yield put(ACTIONS.updateTransactionFailed());
        }
    } catch (err) {
        const errStatus = err && err.response && err.response.status;
        if (
            CONFIG.CONFIG.processTransactionRetryErrorCode.includes(errStatus) &&
            validateCount < CONFIG.CONFIG.processTransactionRetryThreshold &&
            payload.status === 1
        ) {
            yield put(ACTIONS.validateTransaction(payload));
        } else {
            yield put(ACTIONS.updateTransactionFailed());
        }
    }
}

export function* generateFullWarranty({ payload }: ReturnType<typeof ACTIONS.generateFullWarranty>) {
    const endpoint = REST_ENDPOINT.generateFullPDF(payload.warrantyId);
    try {
        const response = yield call(fetchAPI, endpoint);
        if (response) {
            // const fileName = `WarrantyPDF_${payload.warrantyId}.pdf`;
            const fileName = `WarrantyPDF_${payload.warrantyNumber}.pdf`;

            if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                // IE variant
                (window.navigator as any).msSaveOrOpenBlob(
                    new Blob([response.data], {
                        type: "application/pdf",
                    }),
                    fileName
                );
                yield put(ACTIONS.generateFullWarrantyDownloaded());
            } else {
                const url = window.URL.createObjectURL(
                    new Blob([response.data], {
                        type: "application/pdf",
                    })
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                yield put(ACTIONS.generateFullWarrantyDownloaded());
                setTimeout(function () {
                    // For Firefox it is necessary to delay revoking the ObjectURL
                    window.URL.revokeObjectURL(url);
                }, 100);
            }
        }
    } catch (e) {
        console.error(e);
        yield put(ACTIONS.generateFullWarrantyDownloaded());
    }
}

export function* generateFullWarrantyReport() {
    yield takeEvery(ACTION_TYPES.GENERATE_FULL_WARRANTY, generateFullWarranty);
}

export function* generateSummaryWarranty({ payload }: ReturnType<typeof ACTIONS.generateFullWarranty>) {
    const warrantyId = payload.warrantyId;
    const warrantyNumber = payload.warrantyNumber;
    const reviewAndPayEndpoint = REST_ENDPOINT.reviewAndPay.endpoints.getReviewAndPay(warrantyId);

    try {
        const reviewAndPayResponse = yield call(fetchAPI, reviewAndPayEndpoint);
        if (reviewAndPayResponse) {
            const button = document.createElement("button");
            button.onclick = () => generatePdfDocument(reviewAndPayResponse.data, warrantyId, warrantyNumber);
            button.style.display = "none";
            document.body.appendChild(button);
            button.click();
            yield put(ACTIONS.generateSummaryWarrantyDownloaded());
        }
    } catch (err) {
        yield put(GlobalAction.showGlobalError(err));
        yield put(ACTIONS.generateSummaryWarrantyDownloaded());
    }
    
}
export function* generateSummaryWarrantyReport() {
    yield takeEvery(ACTION_TYPES.GENERATE_SUMMARY_WARRANTY, generateSummaryWarranty);
}

export function* downloadWarrantySummaryPDF({ payload }: ReturnType<typeof ACTIONS.generateFullWarranty>) {
    const warrantyNumber = payload.warrantyNumber;
    const downloadWarrantySummaryPdfEndpoint = REST_ENDPOINT.downloadWarrantySummaryPdf(warrantyNumber);

    try {
        const downloadWarrantySummaryPdfResponse = yield call(fetchAPI, downloadWarrantySummaryPdfEndpoint);
        if (downloadWarrantySummaryPdfResponse) {
            const pdfData = downloadWarrantySummaryPdfResponse.data; // The raw PDF string
            const fileName = `Warranty-Summary_${warrantyNumber}.pdf`;
            if (window.navigator &&  (window.navigator as any).msSaveOrOpenBlob) {
                //For older Internet Explorer
                (window.navigator as any).msSaveOrOpenBlob(pdfData, fileName);
            } else {
                const url = window.URL.createObjectURL(
                    new Blob([pdfData], {
                        type: "application/pdf",
                    })
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                yield put(ACTIONS.downloadSummaryPdfSuccess());
                setTimeout(function () {
                    // For Firefox it is necessary to delay revoking the ObjectURL
                    window.URL.revokeObjectURL(url);
                }, 100);
            }
        }
    } catch (err) {
        yield put(GlobalAction.showGlobalError(err));
        yield put(ACTIONS.downloadSummaryPdfFailure());
    }
}
export function* downloadSummaryPDF() {
    yield takeEvery(ACTION_TYPES.DOWNLOAD_SUMMARY_PDF, downloadWarrantySummaryPDF);
}

export function* beginTransaction() {
    yield takeEvery(ACTION_TYPES.INITIATE_TRANSACTION, initiateTransaction);
}

export function* validateTransaction() {
    yield takeEvery(ACTION_TYPES.VALIDATE_TRANSACTION, validatePayment);
}
